/**
 * Header
 *
 * (hides and shows header on scroll)
 */
(function () {
  var header = document.getElementById('masthead');
  if (!header) { return; }

  var prevScroll = window.scrollY || document.documentElement.scrollTop;
  var direction = 0;
  var prevDirection = 0;

  var toggleHeader = function (direction, curScroll) {
    var headerHeight = header.offsetHeight;

    if (direction === 2 && curScroll > headerHeight) {
      header.style.top = -headerHeight + 'px';
      prevDirection = direction;
    } else if (direction === 1) {
      header.style.top = 0;
      prevDirection = direction;
    }
  };

  var checkScroll = function (curScroll) {
    /*
     * Find the direction of scroll
     * 0 - initial, 1 - up, 2 - down
     */
    if (curScroll > prevScroll) {
      // scrolled down
      direction = 2;
    } else if (curScroll < prevScroll) {
      // scrolled up
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  var ticking = false;

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        checkScroll(window.scrollY || document.documentElement.scrollTop);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();
